import 'zone.js';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
  //window['console'].log = function () {};
  //window['console'].info = function () {};
  //window['console'].debug = function () {};
}

// Match staffapp: callback-based CommonAdminService needs Zone-driven change detection.
platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })],
  })
  .catch((err) => console.error(err));
